<template>
    <div style="width: 350px; margin: auto">
        <div size="small" :inline="true">
            <div style="display: flex; align-items: center">
                <el-upload class="avatar-uploader" action="/api/v1/common/upload" accept=".jpg,.jpeg,.JPG,.JPEG,.png,.PNG" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <el-image style="height: 60px; width: 60px; float: left" fit="scale-down" :src="formData.img" :lazy="true">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline" style="font-size: 40px"></i>
                        </div>
                    </el-image>
                    <el-button style="margin-left: 20px" class="el-button--small el-button--primary">upload logo</el-button>
                </el-upload>
            </div>
        </div>
        <el-form size="small" align="center" label-position="left" status-icon :model="formData" :rules="rules" ref="formData" label-width="105px">
            <el-form-item prop="img" hidden align="left">
                <el-input hidden v-model="formData.img"></el-input>
            </el-form-item>
            <el-form-item prop="crafite_name" align="left" label="Name">
                <el-input class="el-input--small" v-model="formData.crafite_name"></el-input>
            </el-form-item>
            <el-form-item prop="crafite_uuid" align="left" label="Trigger ID">
                <el-input :disabled="true" class="el-input--small" v-model="formData.crafite_uuid"></el-input>
            </el-form-item>
            <el-form-item align="left" label="is Q&A">
                <el-switch v-model.number="formData.is_qa" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item align="left" label="Content Type">
                <el-select style="width: 150px" size="small" v-model="formData.crafite_type" default-first-option>
                    <el-option v-for="item in types" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item align="left" label="Subheader">
                <el-input class="el-input--small" type="textarea" v-model="formData.describe"></el-input>
            </el-form-item>
            <el-form-item align="left" label="QC Test Audio">
                <el-row>
                    <el-col :span="12">
                        <el-upload class="avatar-uploader" action="/api/v1/common/upload" accept=".mp3,.MP3" :limit="1" :on-success="handleAudioSuccess">
                            <el-button style="margin-left: 20px" class="el-button--small el-button--primary">upload audio</el-button>
                        </el-upload>
                    </el-col>
                    <el-col v-if="formData.audio_url != ''" :span="10" style="margin-left: 15px">
                        <audio :src="formData.audio_url" style="height: 35px; width: 110px" controls></audio>
                    </el-col>
                </el-row>
            </el-form-item>

            <el-form-item align="right">
                <el-button class="el-button--small" @click="back()">Back</el-button>
                <el-button class="el-button--small el-button--primary" @click="submit('formData')">Save</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "CraftiesUpdate",
    props: {
        closeUpdate: Function,
    },
    data() {
        return {
            types: [
                { id: 0, label: "Craftie" },
                { id: 2, label: "Memory Game" },
                { id: 3, label: "AudioBook" },
                { id: 5, label: 'Trivia Cards'},
                { id: 6, label: 'Token'},
                { id: 7, label: 'Card Set'},
            ],
            rules: {
                crafite_name: [
                    {
                        required: true,
                        message: "Please enter Craftie Name!",
                        trigger: "blur",
                    },
                    { max: 32, message: "Craftie Name can be up to 32 bits!" },
                ],
                crafite_uuid: [
                    {
                        required: true,
                        message: "Please enter craftie id!",
                        trigger: "blur",
                    },
                    {
                        max: 10,
                        min: 10,
                        message: "The length of Craftie Id must be 10!",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value.match(/^\d*$/) == null) {
                                callback(new Error("Craftie Id should be a pure number!"));
                            }
                            callback();
                        },
                    },
                ],
                describe: [{ required: false }],
                type: [{ required: false }],
                is_qa: [{ required: false }],
            },
            formData: {},
            pre: "01",
        };
    },
    mounted() {
        this.formData = this.$util.fetch("craftiesUpdate");
        this.pre = this.formData.crafite_uuid.substring(0, 2);
        this.formData.crafite_uuid = this.formData.crafite_uuid.substring(2);
        console.log(this.formData.img);
    },
    methods: {
        handleAvatarSuccess(res, file) {
            if (res.errcode === 0) {
                this.$message.success("upload successfully!");
                this.formData.img = res.data;
            } else {
                console.log(res.errmsg);
                this.$message.success("upload failed!");
            }
        },
        handleAudioSuccess(res, file) {
            if (res.errcode == 0) {
                this.$message.success("upload successfully!");
                this.formData.audio_url = res.data;
            } else {
                this.$message.success("upload failed!");
            }
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("The size of the uploaded profile picture cannot exceed 2MB!");
            }
            return isLt2M;
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.formData.crafite_type == null) {
                        delete this.formData.crafite_type;
                    }
                    let params = JSON.parse(JSON.stringify(this.formData));
                    params.crafite_uuid = this.pre + this.formData.crafite_uuid;
                    let loading = this.$util.loading();
                    this.$api.rootV1.post(
                        "/web/craftie/editor",
                        params,
                        (res) => {
                            this.$alert("Successfully modified!", "info", {
                                confirmButtonText: "confirm",
                                type: "success",
                                callback: (action) => {
                                    loading.close();
                                },
                            });
                            this.$emit("closeUpdate");
                        },
                        (res) => {
                            this.$message.error("fail to edit!");
                            loading.close();
                        }
                    );
                } else {
                    this.$message.warning("Please check the input data!");
                }
            });
        },
        back() {
            this.$emit("closeUpdate");
        },
    },
};
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 60px;
        color: #8c939d;
        width: 60px;
        height: 60px;
        line-height: 70px;
        text-align: left;
    }

    .avatar {
        width: 60px;
        height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/crafties/CraftiesUpdate.vue